module.exports = __webpack_public_path__ + "img/product_item_5.f3ed1132.png";